// 用户管理
export default {
    name: 'Имя',
    userName: 'имя пользователя',
    role: 'Роль',
    mobileNumberQuery: 'Запрос мобильного номера',
    pleaseChoose: 'пожалуйста, выберите',
    cellphoneNumber: 'телефонный номер',
    licenseType: 'Тип лицензии',
    department: 'отделение',
    addUser: 'Добавить пользователя',
    editUser: 'изменить пользователя',
    pilotCertification: 'Сертификация пилота',
    pendingCertification: 'в ожидании сертификации',
    fail: 'Потерпеть неудачу',
    passThrough: 'пройти через',
    remark: 'Примечание',
    verified: 'проверено',
    notCertified: 'не сертифицирован',
    freeze: 'заморозить',
    check: 'Проверить',
    certificationInformation: 'Информация о сертификации',
    certification: 'Сертификация',
    userAccount: 'Учетная запись пользователя',
    pleaseEnter: 'Пожалуйста входите',
    contactInformation: 'Контакты',
    isDepartment: 'отделение',
    userRole: 'роль пользователя',
    certificationResult: 'Результат сертификации',
    passwordSetting: 'установка пароля',
    operate: 'действовать',
    enterPassword: 'Пожалуйста введите пароль',
    changePassword: 'изменить пароль',
    userAddSuccessfully: 'Пользователь успешно добавлен',
    userEditSuccessfully: 'Пользователь успешно изменен',
    loginPassword: 'логин Пароль',
    personalInfoAuthentication: 'Аутентификация личной информации',
    copyAccountPwd: 'Скопировать пароль учетной записи',
    verifieds: 'проверено',
    actualName: 'настоящее имя',
    idNumber: 'идентификационный номер',
    idPhoto: 'фото на документы',
    addidfacephoto: 'Добавить фото лица на удостоверение личности',
    ptneotIDc: 'Фотография государственного герба удостоверения личности',
    addptneotIDc: 'Добавить фото государственного герба удостоверения личности',
    authenticationType: 'Тип аутентификации',
    model: 'модель',
    grade: 'оценка',
    upload: 'загрузить',
    IDPhoto: 'фото на документы',
    addIDPhoto: 'Добавить фото профиля удостоверения личности',
    potrsotd: 'Фото обратной стороны документа',
    addpotrsotd: 'Добавьте фотографию обратной стороны вашего удостоверения личности',
    idNumberFormatError: 'Ошибка формата идентификационного номера',
    addressEncodingError: 'ошибка кодирования адреса',
    mobileFormatError: 'Неправильный номер телефона',
    CheckDigitError: 'Ошибка контрольной цифры',
    automaticGenerated: 'Создано автоматически',
    manualEntry: 'Ручной ввод',
    allow: 'разрешать',
    prohibit: 'запретить',
    pleaseEnterDept: 'Пожалуйста, выберите отдел',
    pleaseEnterUsername: 'Пожалуйста, введите имя пользователя',
    pleaseEnterUserAccount: 'Пожалуйста, введите учетную запись пользователя',
    pleaseSelectUserRole: 'Пожалуйста, выберите роль пользователя',
    pleaseSelectPasswordSetting: 'Пожалуйста, выберите настройку пароля',
    pleaseEnterYourRealName: 'Пожалуйста, введите ваше настоящее имя',
    plidentificationNumber: 'Пожалуйста, введите идентификационный номер',
    PeCorrectIDNumber: 'Пожалуйста, введите правильный идентификационный номер',
    pUploadIdPhoto: 'Пожалуйста, загрузите свое удостоверение личности',
    uploadIdCardEm: 'Пожалуйста, загрузите фотографию своего удостоверения личности и герба',
    selectAuthenticationType: 'Пожалуйста, выберите тип аутентификации',
    pleaseSelectModel: 'Пожалуйста, выберите модель',
    pleaseSelectLevel: 'Пожалуйста, выберите уровень',
    uploadPassportPhoto: 'Пожалуйста, загрузите фото вашего паспорта',
    uploadPhotoBackYourXId: 'Пожалуйста, загрузите фотографию обратной стороны вашего удостоверения личности',
    copySuccessfully: 'Копировать успешно',
    replicationFailed: 'Ошибка репликации',
    uploadImgFormatWrong: 'Загруженное изображение имеет неверный формат',
    confirmWhetherRestore: 'Подтвердите, нужно ли восстанавливать',
    recover: 'восстанавливаться',
    successfulOperation: 'Успешная операция',
    delUserTip: 'После удаления пользователя его невозможно восстановить, действуйте осторожно!',
    frozenTip: 'Уведомление! После заморозки пользователя он не может войти в систему, но данные пользователя все равно сохраняются!',
    editSuccessTip:'Модификация прошла успешно и вступит в силу после повторного входа в систему.'
}
